<template>
  <div class="subscribe-contianer">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <!-- <star-condition-cell label="用户姓名">
        <a-select
          style="width: 100%"
          v-model="searchCondition.subscriberId"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="(item, index) in userList"
            :key="index"
            :value="item.subscriberId"
          >
            {{ item.accountName }}
          </a-select-option>
        </a-select>
      </star-condition-cell> -->
      <star-condition-cell label="站点名称">
        <a-input v-model="searchCondition.spiderName" allowClear />
      </star-condition-cell>
      <star-condition-cell label="站点类型">
        <a-select style="width: 100%" v-model="searchCondition.spiderClassId" allowClear>
          <a-select-option
            v-for="(item, index) in siteClassList"
            :key="index"
            :value="item.spiderClassId"
          >
            {{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点状态">
        <a-select
          allowClear
          v-model="searchCondition.spiderExecType"
          placeholder="请选择站点状态"
          style="width: 100%"
        >
          <a-select-option :value="0">待运行</a-select-option>
          <a-select-option :value="1">运行</a-select-option>
          <a-select-option :value="-1">暂停</a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="订阅状态">
        <a-select
          allowClear
          v-model="searchCondition.subscribeStatus"
          placeholder="请选择订阅状态"
          style="width: 100%"
        >
          <a-select-option :value="1">订阅中</a-select-option>
          <a-select-option :value="-1">取消订阅</a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="getSiteList" :size.sync="tableDensity" :columns="columns">
        <a-button @click="showSubscribeSettingModal">订阅配置</a-button>
        <a-button type="primary" @click="showDrawer">新增订阅</a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="subscribeRecordId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="subscribeStatus" slot-scope="status">
          <a-badge v-if="status === 1" color="green" text="订阅中"> </a-badge>
          <a-badge v-if="status === -1" color="orange" text="已停用"> </a-badge>
        </span>

        <span slot="execType" slot-scope="text, record">
          <a-badge v-if="record.execType === 1" color="green" text="运行" />
          <a-badge v-else-if="record.execType === 0" color="orange" text="待运行" />
          <a-badge v-else-if="record.execType === -1" color="red" text="暂停" />
        </span>

        <span slot="spiderExecType" slot-scope="text, record">
          <a-badge v-if="record.spiderExecType === 1" color="green" text="运行" />
          <a-badge v-else-if="record.spiderExecType === 0" color="orange" text="待运行" />
          <a-badge v-else-if="record.spiderExecType === -1" color="red" text="暂停" />
        </span>

        <span slot="subscribeStatus" slot-scope="text, record">
          <a-badge v-if="record.subscribeStatus === 1" color="green" text="订阅中" />
          <a-badge v-else-if="record.subscribeStatus === -1" color="red" text="取消订阅" />
        </span>

        <span slot="action" slot-scope="text, record">
          <a-popconfirm
            title="确定要取消订阅吗?"
            @confirm="() => onCancelSubscribe(record)"
            v-if="record.subscribeStatus == 1"
          >
            <a-button type="link">取消订阅</a-button>
          </a-popconfirm>

          <a-popconfirm
            title="确定要再次订阅吗?"
            @confirm="() => reSubscribe(record)"
            v-if="record.subscribeStatus == -1"
          >
            <a-button type="link">再次订阅 </a-button>
          </a-popconfirm>

          <a-divider type="vertical"></a-divider>
          <a-popconfirm title="确定要删除吗?" @confirm="() => onCancelDelete(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <Drawer
      ref="drawer"
      :userList="userList"
      :siteClassList="siteClassList"
      :onSubmit="onDrawerSubmit"
    />

    <a-modal
      title="订阅配置"
      :visible="isShowSettingModal"
      okText="确定"
      cancelText="取消"
      @cancel="cancleSubscribe"
      @ok="onSubscribeFromSubmit"
      :confirmLoading="loadingM"
    >
      <a-form-model
        :model="subscribeFrom"
        layout="horizontal"
        :labelCol="{ span: 5 }"
        :wrapperCol="{ span: 18, offset: 1 }"
        ref="form"
        :rules="rules"
      >
        <a-form-model-item label="用户邮箱" prop="account">
          <a-input v-model="subscribeFrom.account"></a-input>
        </a-form-model-item>

        <a-form-model-item label="推送频次" prop="execTimeCycle">
          <a-input-group compact>
            <a-input-number :min="1" style="width: 50%" v-model="subscribeFrom.execTimeCycle">
            </a-input-number>
            <a-select style="width: 50%" v-model="subscribeFrom.execTimeType">
              <a-select-option :value="2"> 时/次 </a-select-option>
              <a-select-option :value="3"> 天/次 </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="推送内容过滤" prop="filterType">
          <a-radio-group button-style="solid" v-model="subscribeFrom.filterType">
            <a-radio-button :value="0"> 关 </a-radio-button>
            <a-radio-button :value="1"> 开 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item v-if="subscribeFrom.filterType" label="配置过滤词" prop="filterContents">
          <div style="border: 1px solid #ddd; padding: 15px; border-radius: 5px">
            <a-input
              type="text"
              placeholder="按回车键以添加过滤词"
              @keyup.enter.native="addFilterWord"
              v-model="filterWord"
            />
            <ul class="filter-words">
              <li v-for="(item, index) in subscribeFrom.filterContents" :key="index">
                {{ item }}
                <a-icon
                  @click="subscribeFrom.filterContents.splice(index, 1)"
                  type="close-circle"
                  class="icon-close"
                  theme="filled"
                />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Drawer from './Drawer'
import {
  getSubscribeUserApi,
  getSubscribeListApi,
  cancelSubscribeApi,
  reSubscribeApi,
  modifySubscriberApi,
  deleteSubscribeApi,
  getUserInfo
} from '@/api/Subscribe/site'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent } from '@/utils/request'
import { onHttpResponse } from '../../../utils/request'
export default {
  components: { Drawer },
  data() {
    var checkEmail = (rule, value, callback) => {
      const email = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      if (email.test(value)) {
        return callback()
      }
      callback(new Error('邮箱格式不正确'))
    }
    return {
      searchCondition: {
        subscriberId: '',
        spiderClassId: '',
        spiderName: '',
        spiderExecType: '',
        subscribeStatus: ''
      },
      loading: false,
      loadingM: false,
      rules: {
        account: [
          { required: true, message: '请输入用户邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        execTimeCycle: [{ required: true, message: '请输入推送频次', trigger: 'blur' }],
        filterType: [{ required: true, message: '请输入推送内容过滤', trigger: 'change' }],
        filterContents: [{ required: true, message: '请输入配置过滤词', trigger: 'blur' }]
      },
      userList: [],
      siteClassList: [],

      tableDensity: 'middle',
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      columns: [
        {
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          show: true
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          show: true,
          scopedSlots: { customRender: 'spiderClassName' },
          align: 'center'
        },
        {
          title: '国家',
          dataIndex: 'countryName',
          show: true
        },
        {
          title: '站点状态',
          dataIndex: 'spiderExecType',
          show: true,
          scopedSlots: { customRender: 'spiderExecType' },
          align: 'center'
        },
        {
          title: '订阅状态',
          dataIndex: 'subscribeStatus',
          show: true,
          scopedSlots: { customRender: 'subscribeStatus' },
          align: 'center'
        },
        {
          title: '开始订阅时间',
          dataIndex: 'startTime',
          show: true,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 170,
          align: 'center'
        }
      ],
      tableData: [],

      isShowSettingModal: false,
      subscribeFrom: {
        account: '',
        execTimeCycle: 1,
        execTimeType: 2,
        filterType: 0,
        filterContents: []
      },
      filterWord: undefined
    }
  },
  mounted() {
    this.init()
  },

  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    cancleSubscribe() {
      this.isShowSettingModal = false
      this.subscribeFrom.filterType = 0
      this.subscribeFrom.filterContents = []
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    init() {
      Promise.all([this.getSpiderClassInfo()]).then(() => {
        this.getSiteList()
      })
    },

    getGetUser() {
      return getSubscribeUserApi({ pn: 1, pageSize: 1000 })
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.userList = data
          if (this.userList.length) {
            this.searchCondition.subscriberId = this.userList[0].subscriberId
          }
        })
    },

    getSpiderClassInfo() {
      return querySpiderClassInfoApi()
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.siteClassList = data
          if (this.siteClassList.length) {
            // this.searchCondition.spiderClassId = this.siteClassList[0].spiderClassId
          }
        })
    },

    onDrawerSubmit(subscriberId, spiderClassId, spiderName) {
      this.searchCondition.subscriberId = subscriberId
      this.searchCondition.spiderClassId = spiderClassId
      this.searchCondition.spiderName = spiderName
      this.handleSearch()
    },

    handleSearch() {
      this.pagination.current = 1
      this.getSiteList()
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getSiteList()
    },

    showDrawer() {
      this.$refs.drawer.show(this.searchCondition.subscriberId, this.searchCondition.spiderClassId)
    },

    reset() {
      this.searchCondition.spiderName = undefined
      this.searchCondition.spiderExecType = undefined
      this.searchCondition.subscribeStatus = undefined
      this.searchCondition.spiderClassId = undefined
      // subscriberId: '',
      // spiderClassId: '',
      // spiderName: '',
      // spiderExecType: '',
      // subscribeStatus: ''
      if (this.siteClassList.length) {
        // this.searchCondition.spiderClassId = this.siteClassList[0].spiderClassId
      }

      if (this.userList.length) {
        this.searchCondition.subscriberId = this.userList[0].subscriberId
      }

      this.getSiteList()
    },

    getSiteList() {
      // if (this.userList.length === 0) {
      //   this.$message.error('请先添加用户')
      //   return
      // }
      if (this.siteClassList.length === 0) {
        this.$message.error('请先添加站点类别')
        return
      }
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        // subscriberId: this.searchCondition.subscriberId,
        spiderClassId: this.searchCondition.spiderClassId,
        spiderName: this.searchCondition.spiderName,
        spiderExecType: this.searchCondition.spiderExecType,
        subscribeStatus: this.searchCondition.subscribeStatus
      }
      if (query.spiderClassId) {
        // query.spiderName = this.searchCondition.spiderName
      }
      this.loading = true
      getSubscribeListApi(query)
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.tableData = data
          this.pagination.total = extra.page.pageCount
        })
        .finally(() => {
          this.loading = false
        })
    },

    onCancelSubscribe(record) {
      cancelSubscribeApi({ subscribeRecordId: record.subscribeRecordId })
        .then(onHttpResponse)
        .then(() => {
          this.getSiteList()
        })
    },

    reSubscribe(record) {
      reSubscribeApi({ subscribeRecordId: record.subscribeRecordId })
        .then(onHttpResponse)
        .then(() => {
          this.getSiteList()
        })
    },

    onCancelDelete(record) {
      deleteSubscribeApi({ subscribeRecordId: record.subscribeRecordId })
        .then(onHttpResponse)
        .then(() => {
          this.getSiteList()
        })
    },

    showSubscribeSettingModal() {
      getUserInfo()
        .then(onHttpResponseSilent)
        .then((res) => {
          this.subscribeFrom.account = res.extra.data.account
          this.subscribeFrom.execTimeCycle = res.extra.data.execTimeCycle
          this.subscribeFrom.execTimeType = res.extra.data.execTimeType
          this.subscribeFrom.filterType = res.extra.data.filterType
          this.subscribeFrom.filterContents = res.extra.data.filterContents
            ? res.extra.data.filterContents
            : []
        })
      // let user = this.userList.find(
      //   (user) => user.subscriberId === this.searchCondition.subscriberId
      // )
      // if (!user) return
      // this.subscribeFrom.execTimeCycle = user.execTimeCycle || 1
      // this.subscribeFrom.execTimeType = user.execTimeType || 2
      // this.subscribeFrom.account = user.account
      this.isShowSettingModal = true
    },

    onSubscribeFromUserChange(subscriberId) {
      this.subscribeFrom.subscriberId = subscriberId
      let user = this.userList.find((user) => user.subscriberId === subscriberId)
      if (!user) return
      this.subscribeFrom.execTimeCycle = user.execTimeCycle || 1
      this.subscribeFrom.execTimeType = user.execTimeType || 2
    },

    onSubscribeFromSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.subscribeFrom.account) {
            this.$message.error('请填写用户邮箱')
            return
          }
          // let user = this.userList.find((user) => user.subscriberId === this.subscribeFrom.subscriberId)
          let query = {
            // ...user,
            ...this.subscribeFrom
          }
          this.loadingM = true
          modifySubscriberApi(query)
            .then(onHttpResponse)
            .then(() => {
              this.loadingM = false
              this.cancleSubscribe()
              this.getGetUser()
            })
        } else {
          this.$message.error('请检查字段')
        }
      })
    },

    addFilterWord() {
      if (this.filterWord) {
        if (this.subscribeFrom.filterContents.indexOf(this.filterWord) >= 0) {
          this.$message.error('此过滤词已存在')
        } else {
          this.subscribeFrom.filterContents.push(this.filterWord)
          this.filterWord = undefined
        }
      } else {
        this.$message.error('请输入过滤词')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.subscribe-contianer {
  padding: 16px;

  .table-container {
    background: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
.filter-words {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  li {
    height: 40px;
    line-height: 34px;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 0 15px;
    text-align: center;
    margin: 10px 10px 0 0;
    background: #fafafa;
    position: relative;
  }
  li:hover {
    background: #3c93ff;
    color: #fff;
    .icon-close {
      display: block;
    }
  }
  .icon-close {
    color: #ff7875;
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 16px;
    cursor: pointer;
    display: none;
  }
}
</style>
